module.exports = __webpack_public_path__ + "static/roboto-mono-v7-latin-regular-6d5bc1d8c0dc6b8420463d00e33be71a.woff";